import * as Icons from '@ant-design/icons-angular/icons';
export const icons = Object.values(Icons);
